import { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { fetchDocument, findDocuments, selectDocument } from "../common/slices/document";
import { fetchFolders } from "../common/slices/folder";
import Layout, { Content } from "./Layout";
import PDFPreview from "./PDFPreview";
import SidebarDocument from "./SidebarDocument";
import SidebarDocumentList from "./SidebarDocumentList";
import { pathNames } from "../constants";
import { selectActive } from "../common/slices/location";
import { toast } from "react-toastify";
import { ErrorContext } from "../ErrorContext";

const Manage = () => {
    const errorContext = useContext(ErrorContext);
    const dispatch = useDispatch();
    const nav = useNavigate();
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const search = searchParams.get("search") || "";
    const document = useSelector(selectDocument);

    useEffect(() => {
        (async () => {
            try {
                if (search) {
                    await dispatch(findDocuments(search));
                } else {
                    await dispatch(fetchFolders("root"));
                }
            } catch (ex) {
                errorContext.setError({ errorMessage: "Failed to fetch document / folders.", forSupport: ex.message })
            }
        })()
    }, [search, dispatch]);

    useEffect(() => {
        (async () => {
            try {
                if (id) { await dispatch(fetchDocument(id)); }
            } catch (ex) {
                errorContext.setError({ errorMessage: "Failed to fetch document.", forSupport: ex.message })
            }
        })()
    }, [id, dispatch]);

    const onDocumentClick = (d) => {
        nav(`${pathNames.SAFETYFORMS}/manage/${d.id}`);
    };

    return (
        <Layout>
            <div style={{ flex: 1, display: "flex", flexDirection: "row" }}>
                {id ? <SidebarDocument document={document} /> : <SidebarDocumentList onDocumentClick={onDocumentClick} search={search} />}
                <Content style={{ backgroundColor: "#d9d9d9" }}>{id && <PDFPreview document={document} />}</Content>
            </div>
        </Layout>
    );
};
export default Manage;
